if (!Element.prototype.matches) {
    const elementPrototype = Element.prototype;
    Element.prototype.matches =
        elementPrototype.msMatchesSelector ||
            elementPrototype.webkitMatchesSelector;
}
